/**
 * @deprecated
 */
export default function dropdownInputComponent() {
  let _attrs;
  let generateOptions = () => {
    return [_attrs.data.map(o => m('option', { value: o.code }, o.name))];
  }
  return {
    oninit: ({ attrs }) => {
      _attrs = attrs;
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      return [
        m(`.col-md-${_attrs.col ? _attrs.col : 4}`,
          m('label.form-label',
            _attrs.label,
            _attrs.mandatory ? m('span', { "style": { "color": "red" } }, '*') : ''
          ),
          m('select.form-select',
            {
              id: _attrs.id,
              value: _attrs.selectedValue,
              onchange: _attrs.onchange
            }, generateOptions()
          ),
          _attrs.validate && !_attrs.isvalid &&
          m(
            'div', { "class": "invalid-feedback fs-6", style: 'display:block;' },
            m('small', attrs.errorMessage)
          )
        ),
      ]
    }
  };
}
